// Area mapping
// No two can have same stallId
//
import { HALL_KEYS_CONSTANT_DATA } from "./AreaOptionData";


const Hall2_layoutData = [
  {
    "stallId": "Stall2H_193",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_194",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_195",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_196",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_197",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_198",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_199",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_200",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_201",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_202",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_203",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_204",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_205",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_206",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_207",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_208",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_209",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_210",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_211",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_212",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_213",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_214",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_215",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_216",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_217",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_218",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_219",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_220",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_221",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_222",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_223",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_224",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_225",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_226",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_227",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_228",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_229",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_230",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_231",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_232",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_233",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_234",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_235",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_236",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_237",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_238",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_239",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_241",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_242",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_245C",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_245D",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_245E",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_246B",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_246C",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_246E",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_247B",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_247C",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_248B",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_248C",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_249B",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_249C",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_250C",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_251B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_253B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_254C",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_254D",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_255B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_257D",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_257E",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_257F",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_258B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_258C",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2H_259B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_243",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_244",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_245A",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_245B",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_245G",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_245H",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_246A",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_246D",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_247A",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_247D",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_248A",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_248D",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_249A",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_249D",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_250A",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_250B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_250D",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_251A",
    "area": 54,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_252",
    "area": 72,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_253A",
    "area": 54,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_254A",
    "area": 36,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_254B",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_254E",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_255A",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_255C",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_256A",
    "area": 72,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_257A",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_257B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_257G",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_257H",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_258A",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_258AB",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_259A",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_259C",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_1",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_260B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_260C",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_261B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_262B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_263B",
    "area": 54,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_264C",
    "area": 36,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_265B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_268B",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_269B",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_269C",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_270C",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_270D",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_271B",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_271C",
    "area": 27,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_272C",
    "area": 36,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_273C",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_273D",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_273E",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_273F",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_274B",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_274C",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_274D",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_274E",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_275",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2J_276",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_260A",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_260D",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_261A",
    "area": 54,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_262A",
    "area": 54,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_262C",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_263A",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_264A",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_264B",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_264D",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_264E",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_265A",
    "area": 54,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_266",
    "area": 72,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_267",
    "area": 72,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_268A",
    "area": 54,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_269A",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_269D",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_270A",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_270B",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_270E",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_270F",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_271A",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_271D",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_272A",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_272B",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_272D",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_272E",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_273A",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_273B",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_273G",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_273H",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_274A",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_274F",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_277",
    "area": 16,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_278",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_279",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_280",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_281",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_282",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_283",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_284",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_285",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_286",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_287",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_288",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_289",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_290",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_291",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_292",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_293",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_294",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_295",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_296",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_297",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_298",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_299",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_300",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_301",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_302",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_303",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_304",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_305",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_306",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_307",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_308",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_309",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_310",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_311",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_312",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_313",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_314",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_315",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_316",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_317",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_318",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_319",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_320",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_321",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2K_322",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  }
];

const Hall2_Imperial = [
  {
    "stallId": "Stall2F_126",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_127",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_128",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_129",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_130",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_131",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_132",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_133",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_134",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_135",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_136",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_137",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_138",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_139",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_140",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_141",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_142",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2F_143",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_144",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_145",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_146",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_147",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_148",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_149",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_150",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_151",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_152",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_153",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_154",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_155",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_156",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_157",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_158",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_159",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_160",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_161",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_162",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_163",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_164",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_165",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_166",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_167",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_168",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_169",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_170",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_171",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_172",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_173",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_174",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_175",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_176",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_177",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_178",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_179",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_180",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_181",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_182",
    "area": 9,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_183",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_184",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_185",
    "area": 18,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_186",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_187",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_188",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_189",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_190",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  },
  {
    "stallId": "Stall2G_191",
    "area": 12,
    "hallId": "HALL 2",
    "section": "sectionData_2",
    "zone": "2A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor3"
  }
];

const Hall3_layoutData = [
  {
    "stallId": "Stall3L_323",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_324",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_325",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_326",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_327",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_328",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_329",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_330",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_331",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_332",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_333",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_334",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_335",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_336",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_337",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_338",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_339",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_340",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_341",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_342",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_343",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_344",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_345",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_346",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_347",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_348",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_349",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_350",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_351",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_352",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_353",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_354",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_355",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_356",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_357",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_358A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_358B",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_359",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_360",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_361",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_362",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_363D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_363E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_363F",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_363G",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_364B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_364C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_364D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_364E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_365B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_365C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_365D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_365E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_366B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_366C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_366D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_366E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_367B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_367C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_367D",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_368B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_368C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_369B",
    "area": 36,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_362",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_370B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_371B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_371C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_371D",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_370C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_372B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_373C",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_373D",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_372C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_374C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_374D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_375A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_375B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_376C",
    "area": 36,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_377B",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_377C",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3L_374B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_363A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_363B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_363C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_363H",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_364A",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_364F",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_365A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_366A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_367A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_368A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_369A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_370A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_371A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_372A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_373A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_373B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_373E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_373F",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_374A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_376A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_376B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_376D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_376E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_377A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_377D",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_378B",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_378C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_378D",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_380B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_380C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_380D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_380E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_383B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_383C",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_384B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": "",
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_384C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_384D",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_385",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_386",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_387",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_388",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_378A",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3M_379B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_379A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_379C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_380A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_380F",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_380G",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_381",
    "area": 108,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_382A",
    "area": 36,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_382B",
    "area": 108,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_383A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_384A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": "",
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_384E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_390B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": "",
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_390C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_390D",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_391A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_391B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_391C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_392C",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_391D",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_396",
    "area": 36,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_391E",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_392A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_398A",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_392B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_393A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_399C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_393B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_397A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_400C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_400D",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_389",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_390A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_390E",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_390F",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_397B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_398B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_398C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_399A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_399B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_399D",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_399E",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_400A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_399F",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3N_400B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_400E",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_400F",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_401B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_401C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_403C",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_403D",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_404C",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_404D",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_405C",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_405D",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_406C",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_406D",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_402A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_402B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_410B",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_411B",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_411C",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_412C",
    "area": 36,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_414B",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_414C",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_415B",
    "area": 27,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_415C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_415D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_394",
    "area": 108,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_395",
    "area": 108,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_401A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_402C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_402D",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_408A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_408C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_403A",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_403B",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_403E",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_403F",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_404A",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_404B",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_404E",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_404F",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_405A",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_405B",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_405E",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_405F",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_406A",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_406B",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_406E",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_406F",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_407A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_407B",
    "area": 54,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_407C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_408E",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_408B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_408D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3P_409C",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_409A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_409B",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_409D",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_409E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_410A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_410C",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_411A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_411D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_412A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_412B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_412D",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_413",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_414A",
    "area": 18,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_415A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_415E",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_415F",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_416",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_417",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_418",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_2",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_419",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_420",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_421",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_422",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_423",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_424",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_425",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_426",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_427A",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_427B",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_428",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_429",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_430",
    "area": 16,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_431A",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_431B",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_432",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_433",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_434",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_435",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_436",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_437",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_438",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_439",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_440",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_441",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_442",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_443",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_444",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_445",
    "area": 9,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_446",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_447",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_448",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_449",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_450A",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall3Q_450B",
    "area": 12,
    "hallId": "HALL 3",
    "section": "sectionData_1",
    "zone": "3A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  }
];
const Hall4_layoutData = [
  {
    "stallId": "Stall4R_451",
    "area": 108,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12x9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_452A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_452B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_453A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_453B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_454A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_454B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_455A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_455B",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_456",
    "area": 108,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12x9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_457A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_457B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_458A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_458B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_459A",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_459B",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_460A",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_460B",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_461A",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_461B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_461C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_461D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_461E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_462A",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_462B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_462C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_462D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_462E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_462F",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_463A",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_463B",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_463C",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_463D",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_463F",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_465",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_464",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_466",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_467",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_470B",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_470C",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_470D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_470E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_471C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_471D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_471E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_471F",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_472C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_472D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_472E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_472F",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_473C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_473D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_473E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_473F",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_474C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_474D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_474E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_474F",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_475B",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_475C",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_476B",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_476C",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_478B",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_478C",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_479B",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_480B",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4R_481B",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_468",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_469",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_470A",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_470F",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_471A",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_471B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_471G",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_471H",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_472A",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_472B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_472G",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_472H",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_473A",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_473B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_473G",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_474A",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_474B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_474G",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_475A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_475D",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_476A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_476D",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_477A",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_477B",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_478A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_478D",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_479A",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_480A",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_481A",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_482B",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_483B",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_485B",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_485C",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_486B",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_486C",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_487B",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_487C",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_488B",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_488C",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_489C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_489D",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_489E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_490C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_490D",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_490E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_491B",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_491C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_492C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_492D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_492E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_492F",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_493B",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_493C",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_493D",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_493E",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_494",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_495",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_496",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_1",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor8"
  },
  {
    "stallId": "Stall4S_497",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_498",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4S_499",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_482A",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_483A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_483C",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_484A",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_484B",
    "area": 72,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_485A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_485D",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_486A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_486D",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_487A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_487D",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_488A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_488D",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_489A",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_489B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_489F",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_489G",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_490A",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_490B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_490F",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_490G",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_491A",
    "area": 27,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_491D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_491E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_492A",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_492B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_492G",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_492H",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_493A",
    "area": 16,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "4X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_493F",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_493G",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_500A",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_500B",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_500C",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_500D",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_500E",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_500F",
    "area": 12,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X4",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_501A",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_501B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_501C",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_501D",
    "area": 27,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_502A",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_502B",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_502C",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_502D",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_502E",
    "area": 9,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3x3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_503A",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_503B",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_504A",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_504B",
    "area": 18,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_505A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_505B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_506A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_506B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_507A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_507B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_508A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_508B",
    "area": 27,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_508C",
    "area": 27,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_509A",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_509B",
    "area": 36,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_510",
    "area": 108,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12x9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_511A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_511B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_512A",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall4T_512B",
    "area": 54,
    "hallId": "HALL 4",
    "section": "sectionData_2",
    "zone": "4A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  }
];
const Hall5_layoutData = [
  {
    "stallId": "Stall5U_515",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_516",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_517",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_518",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_519",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_520",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_521",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_522",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_523",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_524",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_525",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_526",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_528",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_529",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_531",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_532",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_533",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_534",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_535",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_537",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_539",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_540",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_541",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_542",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_543",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_544",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_545",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_546",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_547",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_548",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_550",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_551",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_552",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_553",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_554",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_555",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_556",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_557",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_558",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_559",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_560",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_561",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_562",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_563",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_564",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_565",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_566",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_567C",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_567D",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_568C",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_568D",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_568E",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_568F",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_569C",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_569D",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_569E",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_569F",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_570C",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_570D",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_570E",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_570F",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_571C",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_571D",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_571E",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_571F",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_572C",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_572D",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_572E",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_572F",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_573B",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_573C",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_574B",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_575B",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_575C",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_576B",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_576C",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_577B",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_578B",
    "area": 36,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_579B",
    "area": 54,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_580B",
    "area": 54,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_581B",
    "area": 36,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_583B",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_583C",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_583D",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_583E",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_583F",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_583G",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5U_583H",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_567A",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_567B",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_568A",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_568B",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_568G",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_568H",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_569A",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_569B",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_569G",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_569H",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_570A",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_570B",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_570G",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_570H",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_571A",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_571B",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_571G",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_571H",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_572A",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_572B",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_572G",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_572H",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_573A",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_573D",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_574A",
    "area": 27,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_574C",
    "area": 27,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_575A",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_575D",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_576A",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_576D",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_577A",
    "area": 27,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_577C",
    "area": 27,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_578A",
    "area": 36,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_579A",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_580A",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_581A",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_581C",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_582",
    "area": 72,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "6X12",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_583A",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_583I",
    "area": 27,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_583J",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_583K",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_583L",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_583M",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_584",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_585",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_586",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_587",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_588",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_589",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_590",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_592",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_13",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_595",
    "area": 27,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_596",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_597",
    "area": 18,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_598",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_599",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_600",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_601",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_602",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_603",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_604",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_605",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_606",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_607",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_608",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_609",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_610",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_611",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_612",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_613",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_614",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_615",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_616",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_617",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_618",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_619",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_620",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_621",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_622",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_623",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_624",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_625",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_626",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "Stall5V_627",
    "area": 9,
    "hallId": "Hall 5",
    "section": "sectionData_12",
    "zone": "5B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "Hall 5",
    "serviceProvider": "vendor7"
  }
];
const Hall6_layoutData = [
  {
    "stallId": "Stall6A_001",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_002",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_003",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_004",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_005",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_006",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_007",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_008",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_009",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_010",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_011",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_013",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_014",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_015B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_015C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_016B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_016C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_017B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_017C",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_018B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_019B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_7",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_037",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6A_038",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X4",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_015A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_016A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_017A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_017D",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_018A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_018C",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_019A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_7",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_019C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_7",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_019D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_7",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_020B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_7",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_020C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_022B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_022C",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_023B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_024B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_024C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6B_025",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_020A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_7",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_020D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_021A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_021B",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_022A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_022D",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_023A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_023C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_024A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_026",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_027B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_027C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_028B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_029B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6C_029C",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_027A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_028A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_028C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_029A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_029D",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_030A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_030B",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_031",
    "area": 72,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_035B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_036B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6D_036C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_032",
    "area": 72,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_033A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_033B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_034A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_034B",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_035A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_035C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_036A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_039",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_040B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6E_040C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_040A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_041A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_041B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_042A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_042B",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_043A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_043B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_044",
    "area": 72,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_049B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_049C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_050",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_051",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6F_052",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_053",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6G_045",
    "area": 72,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6G_046A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6G_046B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6G_047A",
    "area": 72,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X12",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6G_047B",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6G_048A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6G_048B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6G_049A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_054",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_055",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_056",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_057A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_057B",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_058",
    "area": 108,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_059",
    "area": 108,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_060",
    "area": 108,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6H_065",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_061",
    "area": 108,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_062",
    "area": 108,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_063A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_063B",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_064A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_064B",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_066",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_067",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_069B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6J_069C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_068",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_069A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_069D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_069D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_070A",
    "area": 72,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_071A",
    "area": 72,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X12",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_071B",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_072",
    "area": 72,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "FOURSIDE_OPENSTALL",
    "premiumType": "FOURSIDE_OPENSTALL",
    "size": "12X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_073A",
    "area": 54,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X9",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_073B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_074A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_074B",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_075A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_075B",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_076B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_076C",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_078B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_078C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_078D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_078E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_079",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6K_080",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_076A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_076D",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_077A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_077B",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_078A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_078F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_078G",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_078H",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_081",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_082",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_083",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_086B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_086C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_086D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_086E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_087B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_087C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_088B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_088C",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_089B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_089C",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_090A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6L_090B",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_086A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_086F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_086G",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_086H",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_087A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_087D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_088A",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_088D",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_089A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_091A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_091B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_092B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_092C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },

  {
    "stallId": "Stall6M_089D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_089E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },

  {
    "stallId": "Stall6M_092D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_093B",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_093C",
    "area": 27,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_094B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_094C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_095B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_095C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6M_095D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_091C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_092A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_092E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_093A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_093D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_093E",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_094A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_094D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_095A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_095E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_095F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_097B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_097C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_097D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_097E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_098B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_098C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_098D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_099B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_099C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_099F",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_100A",
    "area": 36,
    "hallId": "HALL 6",
    "section": "sectionData_4",
    "zone": "6C",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6X6",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6N_100B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_096A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_096B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_096C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_096D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_096E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_096F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_097A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_097F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_097G",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_097H",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_098A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_098E",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_098F",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_099A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_099D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_100C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_101B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_4",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_101C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_4",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_101D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_4",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_102B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_102C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_103B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_103C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_103D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_103E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_103F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_104B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_104C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_104D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_104E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_105B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_105C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6P_105D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_101A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_4",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_101E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_4",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_101F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_4",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_102A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_102D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_103A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_103G",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_103H",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_103I",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_103J",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_104A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_104F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_104G",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_104H",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_105A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_105E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_105F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_106",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_107",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
 
  {
    "stallId": "Stall6Q_108A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  }, {
    "stallId": "Stall6Q_108B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  }, {
    "stallId": "Stall6Q_108C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_108D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },


  {
    "stallId": "Stall6Q_109",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_110",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_111",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_112",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_113",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_114",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_115",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_116",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_117",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_118",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_119",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_120",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_121",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_122",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_123",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6Q_124",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_124A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_124B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_124C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_124D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_124E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_125A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_125B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_125C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_125D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_125E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_125F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_125G",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6C",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_126A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_126B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_126C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_126D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_126E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_126F",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_126G",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_127A",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_127B",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_127C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_127D",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_127E",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_1",
    "zone": "6B",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_128A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_128B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_128C",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_129A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_129B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_129C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_129D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_130A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_130B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_130C",
    "area": 9,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_130D",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_131A",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  },
  {
    "stallId": "Stall6R_131B",
    "area": 18,
    "hallId": "HALL 6",
    "section": "sectionData_2",
    "zone": "6A",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "BEC",
    "serviceProvider": "vendor2"
  }
];
const HallAurum_layoutData = [
  {
    "stallId": "StallAU_001",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_002",
    "area": 18,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_004",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_005",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_006",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_007",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_008",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_009",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_010",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_011",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_012",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_013",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_014",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_015",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_016",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_017",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_018",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_019A",
    "area": 18,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_019B",
    "area": 27,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_019C",
    "area": 27,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_019D",
    "area": 18,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_020A",
    "area": 54,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9x6",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_020B",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_020C",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_020D",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_020E",
    "area": 36,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_020F",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_020G",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_020H",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_021",
    "area": 18,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X6",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_022",
    "area": 18,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X6",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_023A",
    "area": 54,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9x6",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_023B",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_023C",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_023D",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_023E",
    "area": 36,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "6x6",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_023F",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_023G",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_023H",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_024A",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_024B",
    "area": 27,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_024C",
    "area": 27,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_024D",
    "area": 18,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_025",
    "area": 18,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_026",
    "area": 27,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "9X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_027",
    "area": 18,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "6X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_028",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_029",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_030",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_031",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_032",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_033",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_034",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_035",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_036",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_037",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_038",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_039",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_040",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_041",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_042",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_043",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_044",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "THREESIDE_OPENSTALL",
    "premiumType": "THREESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_045",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_046",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_047",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_11",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 2,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_048",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "TWOSIDE_OPENSTALL",
    "premiumType": "TWOSIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 1,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_049",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_050",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_051",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_052",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_053",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_054",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_055",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  },
  {
    "stallId": "StallAU_056",
    "area": 9,
    "hallId": "AURUM",
    "section": "sectionData_12",
    "zone": "A1",
    "stallDesign": "ONESIDE_OPENSTALL",
    "premiumType": "ONESIDE_OPENSTALL",
    "size": "3X3",
    "stallSideType": 0,
    "venue": "AURUM",
    "serviceProvider": "vendor7"
  }
]

export const HallLayoutData = {
  // [HALL_KEYS_CONSTANT_DATA.Pavillion]: Hall_Jio_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h1]: Hall1_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h2]: [...Hall2_layoutData,...Hall2_Imperial],
  [HALL_KEYS_CONSTANT_DATA.h3]: Hall3_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h4]: Hall4_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h5]: Hall5_layoutData,
  [HALL_KEYS_CONSTANT_DATA.h6]:  Hall6_layoutData,
  [HALL_KEYS_CONSTANT_DATA.aurum]:  HallAurum_layoutData,
  // [HALL_KEYS_CONSTANT_DATA.h7]: Hall7_layoutData,
};


export const LAYOUT_VENU = "BEC"
